<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <demo-login-modal/>
        <demo-register-modal/>
        <router-link to="/" class="navbar-brand"><img src="../../assets/logo3.png"/></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <router-link class="spacing" v-for="routes in links"
                             v-bind:key="routes.id"
                             :to="`${routes.page}`">
                    <li class="nav-item"><a class="nav-link" href="#">{{routes.text}}</a></li>
                </router-link>
                <li v-if="1==2" class="nav-item spacing"><a class="nav-link" target="_blank"
                                                            href="https://carbnp.com/blog">Blog</a></li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
                <router-link to="/account/profile" v-if="logged" style="margin-left: 6.25em;" tag="button"
                             class="btn btn-outline-info my-2 my-sm-0 logginbt" v-text="$ml.get('navbarMyAccount')"/>
                <a v-else @click="$modal.show('demo-login')" style="margin-left: 6.25em;"
                   class="btn btn-outline-info my-2 my-sm-0 logginbt">Login</a>
            </form>
        </div>
    </nav>
</template>

<script>
    import DemoLoginModal from '../modal/login.vue'
    import DemoRegisterModal from '../modal/register.vue'
    export default {
        name: 'alerts',
        components:{
            DemoLoginModal,
            DemoRegisterModal
        },
        data() {
            return {
                logged: !!localStorage.token,
                resizable: false,
                adaptive: false,
                draggable: false,
                canBeShown: false,
                links: [
                    {
                        id: 0,
                        text: 'Inicio',
                        page: '/'
                    },
                    {
                        id: 1,
                        text: 'Catálogo',
                        page: '/catalogue'
                    },
                    {
                        id: 2,
                        text: 'FAQs',
                        page: '/faqs'
                    },
                    {
                        id: 3,
                        text: 'Contacto',
                        page: '/contact'
                    }
                ]
            }
        }
    };
</script>
<style scoped>
    .logginbt:hover {
        background: #00bcd4 !important;
        color: white !important;
    }

    .nav-link:hover {
        color: #00bcd4 !important;
    }
</style>